import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
import { sectionRenderer } from '@theme/section-renderer';
class WBSideCart extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.changeQuantity);
    this.addEventListener('submit', this.onCheckout);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    document.addEventListener(StandardEvents.cartDiscountUpdate, this.onCartUpdate);
    window.addEventListener('pageshow', this.onPageShow);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.changeQuantity);
    this.removeEventListener('submit', this.onCheckout);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    document.removeEventListener(StandardEvents.cartDiscountUpdate, this.onCartUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
  }
  open = () => { if (matchMedia('(min-width:750px)').matches && this.querySelector('[data-has-items="true"]')) { this.dataset.open='true'; document.querySelector('.action__cart')?.setAttribute('aria-expanded','true'); this.renderRecommendations(); } };
  renderRecommendations = async () => { try { const cart=JSON.parse(this.querySelector('[data-bag-cart]').textContent); const {renderBagRecommendations}=await import('./wb-mobile-cart-confirmation.js?v=1792539001'); await renderBagRecommendations(this,cart); } catch {} };
  close = () => { delete this.dataset.open; document.querySelector('.action__cart')?.setAttribute('aria-expanded','false'); };
  onKeyDown = event => { if(event.key==='Escape' && this.dataset.open==='true'){this.close();document.querySelector('.action__cart')?.focus();} };
  onDocumentClick = event => {
    if(event.target.closest('[data-bag-close]')){this.close();document.querySelector('.action__cart')?.focus();return;}
    const cartLink=event.target.closest('.action__cart');
    if(cartLink && matchMedia('(min-width:750px)').matches && this.querySelector('[data-has-items="true"]')){event.preventDefault();this.dataset.open==='true'?this.close():this.open();return;}
    if(!this.contains(event.target))this.close();
  };
  onCheckout = event => { if (this.busy) event.preventDefault(); };
  onPageShow = event => { if (event.persisted) this.refresh().catch(() => {}); };
  refresh = async () => {
    const list = this.querySelector('.wb-side-cart-items');
    const scroll = list?.scrollTop || 0;
    await sectionRenderer.renderSection(this.dataset.sectionId, { cache: false, mode: 'hydration' });
    const updated = this.querySelector('.wb-side-cart-items');
    if (updated) updated.scrollTop = scroll;
    if (this.dataset.open === 'true') this.renderRecommendations();
  };
  onCartUpdate = event => {
    if (event.target === this) return;
    event.promise?.then(result => {
      if (!result?.detail?.didError) return this.refresh().then(()=>{if(event.action==='add')this.open();});
    }).catch(() => {});
  };
  changeQuantity = async event => {
    const button = event.target.closest('button[data-quantity]');
    if (!button || this.busy) return;
    const row = button.closest('[data-key]');
    const key = row.dataset.key, quantity = Number(button.dataset.quantity);
    const error = this.querySelector('.wb-side-cart-error');
    error.hidden = true;
    this.busy = true;
    this.querySelector('.wb-side-cart-content').setAttribute('aria-busy', 'true');
    const deferred = CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(() => {});
    this.dispatchEvent(new CartLinesUpdateEvent({ action: quantity ? 'update' : 'remove', context: 'cart', lines: [{ id: key, quantity }], promise: deferred.promise }));
    try {
      const response = await fetch(this.dataset.changeUrl + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await response.json();
      if (!response.ok || cart.errors) throw new Error(cart.description || cart.message || this.dataset.error);
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, itemCount: cart.item_count, source: 'wb-side-cart', didError: false } });
      await this.refresh();
      const replacement = [...this.querySelectorAll('[data-key]')].find(item => item.dataset.key === key);
      (replacement?.querySelector('button') || this.querySelector('.wb-side-cart-link'))?.focus({ preventScroll: true });
    } catch (failure) {
      deferred.reject(failure);
      error.textContent = failure.message || this.dataset.error;
      error.hidden = false;
    } finally {
      this.busy = false;
      this.querySelector('.wb-side-cart-content')?.removeAttribute('aria-busy');
    }
  };
}
if (!customElements.get('wb-side-cart')) customElements.define('wb-side-cart', WBSideCart);
